import { render } from "./Form.vue?vue&type=template&id=50d3d7e2&scoped=true"
import script from "./Form.vue?vue&type=script&lang=js"
export * from "./Form.vue?vue&type=script&lang=js"

import "./Form.vue?vue&type=style&index=0&id=50d3d7e2&lang=scss"
import "./Form.vue?vue&type=style&index=1&id=50d3d7e2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50d3d7e2"]])

export default __exports__